"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
var Locale_1 = require("../../../Locale");
function findCat(catItem, cat) {
  if (!Array.isArray(catItem)) {
    if (catItem.name === cat) {
      return catItem;
    }
  }
  for (var _i = 0, _a = Array.isArray(catItem) ? catItem : catItem.items || []; _i < _a.length; _i++) {
    var nextCat = _a[_i];
    var found = findCat(nextCat, cat);
    if (found) {
      return found;
    }
  }
  return null;
}
function FilterMenu(props) {
  var cat = props.cat;
  var categories = reconnect_js_1.useOutlet(props.categories)[0];
  var _a = react_1.useState([]),
    openKeys = _a[0],
    setOpenKeys = _a[1];
  react_1.useEffect(function () {
    var _a;
    if (!cat) {
      return;
    }
    var _nestedCategory = categories.filter(function (c) {
      var _a;
      return (((_a = c.items) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
    });
    var defaultOpenKeys = (_a = _nestedCategory.find(function (c) {
      var _a;
      return !!((_a = c.items) === null || _a === void 0 ? void 0 : _a.find(function (i) {
        return i.name === cat;
      }));
    })) === null || _a === void 0 ? void 0 : _a.name;
    setOpenKeys(defaultOpenKeys ? [defaultOpenKeys + "-sub"] : []);
  }, [cat, categories]);
  return react_1.default.createElement(antd_1.Menu, {
    style: {
      width: 256,
      position: 'sticky',
      top: 84
    },
    mode: "inline",
    openKeys: openKeys,
    onOpenChange: function onOpenChange(openKeys) {
      setOpenKeys(openKeys);
    },
    selectedKeys: cat ? [cat] : []
  }, categories.map(function (topLevel) {
    return renderSubFilterMenu(__assign(__assign({}, props), {
      subCat: topLevel.name
    }));
  }));
}
function renderSubFilterMenu(props) {
  var updateCat = props.updateCat,
    subCat = props.subCat;
  var categories = reconnect_js_1.getOutlet(props.categories).getValue();
  var onMenuClick = function onMenuClick(cat) {
    return function () {
      var pub = typeof cat.public === 'undefined' ? true : cat.public;
      if (!pub) {
        antd_1.message.warn('尚未開放，敬請期待');
        return;
      }
      updateCat(cat.name);
    };
  };
  var topLevel = findCat(categories, subCat);
  if (!topLevel) {
    return null;
  }
  if (Array.isArray(topLevel.items) && topLevel.items.length > 0) {
    return react_1.default.createElement(antd_1.Menu.SubMenu, {
      key: topLevel.name + "-sub",
      title: Locale_1.F(topLevel, 'display')
    }, react_1.default.createElement(antd_1.Menu.Item, {
      key: topLevel.name,
      onClick: onMenuClick(topLevel)
    }, Locale_1.L('all'), " ", Locale_1.F(topLevel, 'display')), topLevel.items.map(function (nextLevel) {
      return renderSubFilterMenu(__assign(__assign({}, props), {
        subCat: nextLevel.name
      }));
    }));
  } else {
    return react_1.default.createElement(antd_1.Menu.Item, {
      key: topLevel.name,
      onClick: onMenuClick(topLevel)
    }, Locale_1.F(topLevel, 'display'));
  }
}
exports.default = FilterMenu;